module.exports = __webpack_public_path__ + "img/phone.89d19a6f.png";